
import Vue from 'vue'
import RPHTextCollapsible from 'rph/molecules/RPHTextCollapsible/index.vue'

export default Vue.extend({
  name: 'RPHSeoText',
  components: {
    RPHTextCollapsible,
  },
  props: {
    seoText: {
      type: String,
    },
    page: {
      type: String,
    },
  },
  data() {
    return {}
  },
  computed: {
    isMobileApp() {
      return this.$store.getters['rph-main/isMobileApp']
    }
  },
  methods: {},
})
